export default "__VITE_ASSET__CoIq9NkF__"